import React from "react";
import { Modal, Button } from "react-bootstrap";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import "./Logout.css";

const LogoutModal = ({ show, onClose }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    Cookies.remove("super_admin_security");
    onClose();
    navigate("/");
  };

  return (
    <Modal show={show} onHide={onClose} centered className="logout-modal">
      <Modal.Header closeButton>
        <Modal.Title>Logout</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p className="logout-message">Are you sure you want to logout?</p>
      </Modal.Body>

      <Modal.Footer>
        <Button type="button" className="logout-no-btn" onClick={onClose}>
          No
        </Button>

        <Button type="button" className="logout-yes-btn" onClick={handleLogout}>
          Yes
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default LogoutModal;
